import React from 'react';
import { Globe, Shield, UserCheck, Languages } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  1: Globe,
  2: Shield,
  3: UserCheck,
  4: Languages
};

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-24 lg:py-32 bg-[#f5f0e8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16 lg:mb-20">
          <span className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-4 block">
            Our Excellence
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#2c2825] mb-6" style={{ fontWeight: 400 }}>
            Why Choose Us
          </h2>
          <div className="w-16 h-px bg-[#c9b896] mx-auto" />
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[item.id];
            return (
              <div
                key={item.id}
                className="group text-center p-8 bg-[#faf8f5] hover:bg-[#2c2825] transition-all duration-500"
              >
                <div className="mb-6 flex justify-center">
                  <div className="w-16 h-16 flex items-center justify-center border border-[#c9b896] group-hover:border-[#c9b896] transition-colors duration-500">
                    <Icon 
                      size={28} 
                      className="text-[#c9b896] group-hover:text-[#c9b896] transition-colors duration-500" 
                      strokeWidth={1.5}
                    />
                  </div>
                </div>
                <h3 className="font-display text-xl text-[#2c2825] group-hover:text-[#faf8f5] mb-4 transition-colors duration-500" style={{ fontWeight: 500 }}>
                  {item.title}
                </h3>
                <p className="text-sm text-[#5a5652] group-hover:text-[#faf8f5]/80 leading-relaxed transition-colors duration-500">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
